export * from './local';
export * from './orders';
export * from './nav-items';
export * from './search';
export * from './loyalty';
export * from './categories';
export * from './privacyPolicy';
export const INTERNAL_REQUEST_TIMEOUT_MS = 2000;
export const OVER_18_YEAR_OLD_IMAGE =
  'https://lh3.googleusercontent.com/5mBwEcEB9rlGJSzrG1DBkiiuwCAwo0oGgjanB_wk3uP8jG-AERDd8buJQ19fmHCTOhA8GxFqV7dZlZhGJfixDlVFjMxNHvLufg';

// please do not export ibank from here
// it would affect server code
// export * from './ibank';
